<div class="header" fxLayout fxLayoutAlign="space-between center">
  <span class="title">{{ 'MANAGE_OFFBOARDING_REQUIREMENTS' | translate }}</span>
  <div class="header-actions" fxLayout fxLayoutAlign="flex-end center" fxLayoutGap="24px">
    <button
      mat-button
      class="header-button"
      fxLayout
      fxLayoutAlign="center center"
      [disabled]="isCreating"
      (click)="toggleCreationMode()"
    >
      {{'CREATE_NEW_ROLE' | translate}}
    </button>

    <mat-icon class="close" (click)="close()">close</mat-icon>
  </div>
</div>

<app-offboarding-requirements
  [isCompanyView]="false"
  [isCreating]="isCreating"
  [isOrderView]="data?.isOrderView"
  [companies]="data?.companies"
  [_roles]="data?.roles"
  (creationChange)="onCreationChange($event)"
  (mergedOrderChange)="closeDialog($event)"
  (dialogCloseChange)="closeDialog($event)"
></app-offboarding-requirements>
